import { PageMeta } from "@/components/PageMeta";
import { SectionHeading } from "@/components/SectionHeading";
import { GlassPanel } from "@/components/GlassPanel";
import { StatusBadge } from "@/components/StatusBadge";
import { CtaLink } from "@/components/Button";
import { docSurfaces } from "@/content/docs";
import { routeSeo } from "@/content/seo";

export function DocsPage() {
  const seo = routeSeo["/docs"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/docs" />

      <section className="container page-hero">
        <p className="eyebrow">Docs</p>
        <h1 className="page-hero-title">What you can build with today</h1>
        <p className="page-hero-lede">
          Devory is early, and the SDK and CLI are earlier still. This page states what each surface
          actually does right now, not what it will eventually do. It covers the same components,
          protocols and interfaces a human developer or an AI agent uses to compose with Devory,
          documented at whatever depth is real today. Nothing below is a simplified tutorial
          standing in for a missing feature.
        </p>
      </section>

      <section className="container section" aria-labelledby="surfaces-heading">
        <SectionHeading level={2} title={<span id="surfaces-heading">Developer surfaces</span>} />
        <div className="grid-2">
          {docSurfaces.map((surface) => (
            <GlassPanel as="article" key={surface.id} className="audience-card">
              <div className="capability-card-head">
                <h3>{surface.title}</h3>
                <StatusBadge status={surface.status} />
              </div>
              <p>{surface.body}</p>
              {surface.link ? (
                <CtaLink to={surface.link.to} variant="secondary">
                  {surface.link.label}
                </CtaLink>
              ) : null}
            </GlassPanel>
          ))}
        </div>
      </section>

      <section className="container section-tight" aria-labelledby="why-thin-heading">
        <GlassPanel className="problem-card">
          <SectionHeading
            level={2}
            title={<span id="why-thin-heading">Why this page is short</span>}
          />
          <p>
            A reference for a capability that does not exist yet is not documentation. It is a
            promise dressed up as one. As the SDK, CLI and protocol surfaces above become real, this
            page grows with them, in the same honest, dated way as the rest of the site.
          </p>
        </GlassPanel>
      </section>

      <section className="container section-tight">
        <GlassPanel className="cta-banner">
          <h2>Building against Devory already?</h2>
          <p>
            Tell Devory what you are trying to build. It directly shapes what ships in the SDK and
            CLI next.
          </p>
          <div className="cta-banner-actions">
            <CtaLink to="/contact" variant="primary">
              Contact Devory
            </CtaLink>
            <CtaLink to="/components" variant="secondary">
              Read the component model
            </CtaLink>
          </div>
        </GlassPanel>
      </section>
    </>
  );
}
